import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitGetSmerItem = {
  user: string;
  smerId: string;
};

export type ComparisonItem = {
  id: string;
  score: number;
  text: string;
};

export type Emotion = {
  name: string;
  value: number;
};

export type Comparison = {
  againstScore: number;
  commonScore: number;
  forScore: number;
  comparisonFor: ComparisonItem[];
  comparisonAgainst: ComparisonItem[];
};

export type SMER_FULL = {
  id: string;
  user: string;
  beliefLevel: number;
  newBeliefLevel?: number;
  behaviour?: string;
  behaviourBin?: string;
  thoughts?: string;
  thoughtsBin?: string;
  conclusion?: string;
  conclusionBin?: string;
  solution?: string;
  solutionBin?: string;
  event?: string;
  eventBin?: string;
  feelInBody?: string;
  feelInBodyBin?: string;
  errors: string[];
  emotions: Emotion[];
  comparison?: Comparison;
  comparisonBin?: string;
  creationDate?: Date;
};

export type ResponseGetSmerItem = SMER_FULL;

export const getSmerItem = async (data: SubmitGetSmerItem) => {
  const response = await axios.get(`${rootUrl}/psychologist/smer/item`, {
    params: {
      user: data.user,
      smerId: data.smerId,
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
